import { render, staticRenderFns } from "./quxianzonghe.vue?vue&type=template&id=666e3324&scoped=true&"
import script from "./quxianzonghe.vue?vue&type=script&lang=js&"
export * from "./quxianzonghe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e3324",
  null
  
)

export default component.exports